import {msg} from "@lingui/macro"
import {useLingui} from "@lingui/react"
import {
    Box,
    Button,
    Card,
    CardContent,
    CardHeader,
    IconButton,
    Grid,
    Modal,
    Switch,
    TextField,
    Typography,
    Divider
} from "@mui/material"
import {useEffect, useState} from "react"
import {Controller, useForm} from "react-hook-form"
import {SketchPicker} from 'react-color'
import httpReq from "../../../../services/httpReq"
import DeleteIcon from '@mui/icons-material/Delete'
import FullPageLoader from "../../../loaders/FullPageLoader"
import SaveIcon from '@mui/icons-material/Save'
import CloseIcon from '@mui/icons-material/Close'

const ModalManageValue = ({
                            valueToEdit,
                            isMobile,
                            setValueToEdit,
                            isOpenModalManageValue,
                              setIsOpenModalManageValue,
                            tagToEdit
                        }) => {
    const {_} = useLingui()

    const [valueRecord,setValueRecord] = useState(valueToEdit ? valueToEdit : {
        value:'',
        color: 'gray',
        isDefault: false
    })
    const {control,reset, formState, handleSubmit, getValues} = useForm({
        mode: 'onChange',
        defaultValues: {
            value: valueRecord?.value,
            color: valueRecord?.color,
            isDefault: valueRecord?.isDefault
        }
    })
    const [photoPreviewUrl, setPhotoPreviewUrl] = useState(null)
    const [photoFile, setPhotoFile] = useState(null)
    const [valueColor, setValueColor] = useState(valueRecord?.color || '')
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {

        setTimeout(() => {
            setIsLoading(true)
            const v = {...valueRecord}
            v.fileContent = v.fileSrc
            const pp = convertMetadataToFile(v)
            if (pp) {
                delete pp._meta
                const previewUrl = URL.createObjectURL(pp)
                setPhotoPreviewUrl(previewUrl)
                setPhotoFile(pp)
            }
            setIsLoading(false)
        }, 100)

    }, [])

    function convertMetadataToFile(data) {
        if (!data.fileContent) {
            return;
        }
        const base64 = data.fileContent.split(',').pop();
        const byteString = atob(base64);
        const arrayBuffer = new ArrayBuffer(byteString.length);
        const uint8Array = new Uint8Array(arrayBuffer);

        for (let i = 0; i < byteString.length; i++) {
            uint8Array[i] = byteString.charCodeAt(i);
        }

        const fileName = data.fileName || `file${data.fileExtension || '.bin'}`;
        const mimeType = data.fileMimeType || 'application/octet-stream';

        const file = new File([uint8Array], fileName, {type: mimeType});
        file._meta = {
            color: data.color,
            isDefault: data.isDefault,
            tag: data.tag,
            value: data.value,
            id: data.id
        };

        return file;
    }

    const handlePhoto = (e) => {
        const file = e.target.files[0]
        if (file) {
            const previewUrl = URL.createObjectURL(file);
            setPhotoPreviewUrl(previewUrl)
            setPhotoFile(file)
        }
    }

    useEffect(() => {
        setPhotoPreviewUrl()
    }, [])

    const getValue = (value) => {
        return value ?? '0,0,0';
    };

    const getRGBJson = (color) => {
        const cols = color.split(',');
        return {r: cols[0], g: cols[1], b: cols[2]};
    };

    const getStringFromRGB = (color) => {
        console.log('color --- ', color)
        return color.rgb.r + ',' + color.rgb.g + ',' + color.rgb.b;
    };

    const getHexFromRGB = (color) => {
        setValueColor(color.hex)
    }

    const updateValue = async () => {
        setIsLoading(true)
        const v = Object.assign(valueRecord, getValues())
        v.color = valueColor

        if (photoFile) {
            const MAX_FILE_SIZE_MB = 2
            const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024

            if (photoFile.size > MAX_FILE_SIZE_BYTES) {
                alert(`Max image size is ${MAX_FILE_SIZE_MB} MB.`)
                setIsLoading(false)
                return
            }

            const fileTypeSplit = photoFile.type.split('/')


            const filereader = new FileReader()
            filereader.readAsDataURL(photoFile)
            filereader.onload = async evt => {
                const base64 = evt.target.result
                const base64Split = base64.split('base64,')
                const data = {
                    id: v.id,
                    value: v.value,
                    color: v.color,
                    isDefault: v.isDefault,
                    fileExtension: `.${fileTypeSplit[1]}`,
                    fileMimeType: photoFile.type,
                    fileContent: base64Split[1]
                }
                let response;

                if(valueToEdit) {
                    response = await httpReq(`TagValue/Update`, 'PATCH', data, true)
                } else {
                    response = await httpReq(`TagValue/Insert/` + tagToEdit.id, 'POST', data, true)
                }
                if (!response || response.responseAnyError) return;
                if (!response.responseAnyError) {
                    setValueToEdit(v)
                    setIsLoading(false)
                    setIsOpenModalManageValue(false)

                    if (!tagToEdit.isMultiple && data.isDefault) {
                        const defaultValues = [...tagToEdit.values].filter(v => v.isDefault && v.id !== data.id)
                        if (defaultValues.length > 0) {
                            const pool = defaultValues.map(async value => {
                                const data = {
                                    id: value.id,
                                    value: value.value,
                                    color: value.color,
                                    isDefault: false,
                                    fileExtension: value.fileExtension,
                                    fileMimeType: value.fileMimeType,
                                    fileContent: value.fileContent
                                }
                                const response = await httpReq(`TagValue/Update`, 'PATCH', data, true)
                                if (!response || response.responseAnyError) return;
                                if (!response.responseAnyError) {
                                    return response.responseData
                                }
                            })
                            await Promise.all(pool)
                        }
                    }
                }
            }
        } else {
            const data = {
                id: v.id,
                value: v.value,
                color: v.color,
                isDefault: v.isDefault,
                fileExtension: '',
                fileMimeType: '',
                fileContent: ''
            }
            let response;
            if(valueToEdit){
                response = await httpReq(`TagValue/Update`, 'PATCH', data, true)
            } else {
                response = await httpReq(`TagValue/Insert/`+tagToEdit.id, 'POST', data, true)
            }
            if (!response || response.responseAnyError) return;
            if (!response.responseAnyError) {
                setValueToEdit(v)
                if (!tagToEdit.isMultiple && data.isDefault) {
                    const defaultValues = [...tagToEdit.values].filter(v => v.isDefault && v.id !== data.id)
                    if (defaultValues.length > 0) {
                        const pool = defaultValues.map(async value => {
                            const data = {
                                id: value.id,
                                value: value.value,
                                color: value.color,
                                isDefault: false,
                                fileExtension: value.fileExtension,
                                fileMimeType: value.fileMimeType,
                                fileContent: value.fileContent
                            }
                            const response = await httpReq(`TagValue/Update`, 'PATCH', data, true)
                            if (!response || response.responseAnyError) return;
                            if (!response.responseAnyError) {
                                return response.responseData
                            }
                        })
                        await Promise.all(pool)
                    }
                }


                setIsLoading(false)
                setIsOpenModalManageValue(false)
            }
        }
        setValueRecord({
            value: '',
            isDefault: false,
            color: ''
        })
    }



    return (
        <Modal sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}} open={isOpenModalManageValue}>
            <Card sx={{width: '50vw', height: 'auto'}}>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        px: 2,
                        py: 1.5,
                    }}
                >

                    <Typography variant="h6" sx={{flex: 1}}>
                        {valueToEdit ? `Edit ${valueToEdit.value}` : 'Add value'}
                    </Typography>

                    <Box sx={{flex: 1, display: 'flex', justifyContent: 'flex-end', gap: 1}}>
                        <Button sx={{borderRadius: 10}} variant="contained" disabled={!formState.isValid}
                                onClick={() => updateValue()}>
                            <SaveIcon color={!formState.isValid ? 'inherit' : 'white'}/>
                        </Button>
                        <IconButton onClick={() => {
                            setValueToEdit(null);
                            setIsOpenModalManageValue(false)
                        }
                        }><CloseIcon color="error"/></IconButton>
                    </Box>
                </Box>
                <CardContent>
                    <Grid container spacing={1}>
                        <Grid item container xs={12} lg={8}>
                            {/**<Grid container spacing={2}> */}
                            <Grid item xs={12}>
                                <Controller
                                    name='value'
                                    control={control}
                                    defaultValue=""
                                    render={({field, fieldState}) => (
                                        <TextField
                                            margin={isMobile ? 'dense' : 'normal'}
                                            fullWidth
                                            required
                                            label={_(msg`Value Name`)}
                                            autoComplete='value'
                                            autoFocus
                                            error={!!fieldState.error}
                                            helperText={fieldState.error ? fieldState.error.message : null}
                                            {...field}
                                        />
                                    )}
                                    rules={{required: _(msg`Value Name is required`)}}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Controller name='isDefault'
                                            control={control}
                                            render={({
                                                         field: {onChange, onBlur, value, name, ref},
                                                         fieldState,
                                                         formState
                                                     }) => (
                                                <Box sx={{display: 'flex', alignItems: 'center'}}>
                                                    <Typography>Is default tag?</Typography>
                                                    <Switch
                                                        margin={isMobile ? 'dense' : 'normal'}
                                                        fullWidth
                                                        label={_(msg`Is the default tag`)}
                                                        checked={value}
                                                        autoComplete='isDefault'
                                                        error={!!fieldState.error}
                                                        onChange={(event, newValue) => {

                                                            onChange(newValue)
                                                        }}
                                                        helperText={fieldState.error ? fieldState.error.message : null}/>
                                                </Box>
                                            )}
                                />
                            </Grid>
                            <Grid item xs={12}
                                  sx={{display: 'flex', justifyContent: 'flex-end', gap: 2}}>
                                <Button variant="contained" component="label">
                                    Upload image
                                    <input
                                        type="file"
                                        accept="image/*"
                                        hidden
                                        onChange={handlePhoto}
                                    />
                                </Button>
                                <Button
                                    variant="contained" component="label"
                                    disabled={!photoPreviewUrl}
                                    onClick={() => {
                                        setPhotoPreviewUrl(null);
                                        setPhotoFile(null);
                                    }}

                                >
                                    Clear image
                                </Button>
                            </Grid>

                            <Grid xs={12} sx={{
                                height: '40vh',
                                mt: 2,
                                display: 'flex',
                                border: '1px solid lightgray',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}>
                                {photoPreviewUrl &&
                                    <img
                                        src={photoPreviewUrl}
                                        alt="Preview"
                                        style={{
                                            objectFit: 'contain',
                                            width: 'auto',
                                            height: '90%',
                                            borderRadius: 8
                                        }}
                                    />
                                }
                            </Grid>

                            {/**}</Grid>*/}
                        </Grid>
                        <Grid item container xs={12} lg={4}>
                            <Grid item xs={12}>
                                <TextField
                                    margin={isMobile ? 'dense' : 'normal'}
                                    fullWidth
                                    required
                                    disabled
                                    value={valueColor}
                                />
                            </Grid>
                            <Grid item xs={12} sx={{display:'flex',justifyContent:'center'}}>
                                <SketchPicker
                                    name={`color-picker-${valueRecord?.name || 'value'}`}
                                    key={`color-picker-${valueRecord?.name || 'value'} `}
                                    color={valueColor}
                                    onChange={(color) => {
                                        getHexFromRGB(color);
                                    }}
                                />
                            </Grid>
                        </Grid>


                    </Grid>
                </CardContent>

                {isLoading && <FullPageLoader/>}
            </Card>
        </Modal>
    )
}
export default ModalManageValue
